export default __webpack_public_path__ + "static/media/childDevelopmnet-blob4.7fcb4eda.svg";